import React from 'react';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { AutoUpgradeNotATrialBanner as AutoUpgradeNotATrialBannerType } from './banner.tsx';

export const AutoUpgradeNotATrialBanner = lazyForPaint<typeof AutoUpgradeNotATrialBannerType>(
	() =>
		import(/* webpackChunkName: "async-auto-upgrade-not-a-trial-banner" */ './banner.tsx').then(
			(module) => module.AutoUpgradeNotATrialBanner,
		),
	// eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
	{ ssr: true, entryFsSsrLiftImportToModule: true, includeInShellOnlySsrBundle: true },
);

export const AsyncAutoUpgradeAvoidDeactivationBanner = () => {
	if (fg('auto_upgrade_not_a_trial_jira_gate')) {
		return (
			<Placeholder name="async-auto-upgrade-not-a-trial-banner" fallback={null}>
				<AutoUpgradeNotATrialBanner />
			</Placeholder>
		);
	}
};

export default AsyncAutoUpgradeAvoidDeactivationBanner;
